// extracted by mini-css-extract-plugin
export default {"categoriesContainer":"Category_categoriesContainer__8Ukm7"};